// All user related database operations can be defined here.

import http from "../http-common";

class ContentDataService {
  getContent(id: string, disableCache: boolean = false) {
    let qs = ""
    if(disableCache)
      qs = `?ts=${new Date().getTime()}`

    return http.get(`content/${id}${qs}`);
  }
  getChildren(id: string, disableCache: boolean = false) {
    let qs = ""
    if(disableCache)
      qs = `?ts=${new Date().getTime()}`

    return http.get(`content/${id}/children${qs}`);
  }
  getPage(url: string, disableCache: boolean = false) {
    let qs = ""
    if(disableCache)
      qs = `&ts=${new Date().getTime()}`

    return http.get(`content/url?url=${encodeURIComponent(url)}${qs}`);
  }
  getGlossary() {
    return http.get(`glossary`);
  }
}

const datservice = new ContentDataService();

export default datservice;
